<template id="app">
  <v-card class="overflow-hidden v-card v-sheet theme--light m-0">
    <div style="max-height: 106px;">
      <HeaderComponent :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()" />
    </div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-dialog v-model="imagePopup" persistent max-width="800px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <span style="font-weight: 600;">View Images</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="imagePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <div>
                  <v-img :src="box_images_images[0]" style="height: 350px;" />
                </div>
                <div class="text-center mt-3">
                  <strong>Box S/N Number</strong>
                </div>
              </v-col>
              <v-col>
                <div>
                  <v-img v-if="box_images_images.length > 1" :src="box_images_images[1]" style="height: 350px;" />
                </div>
                <div class="text-center mt-3">
                  <strong>Product S/N Number</strong>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center" class="m-0">
      <v-dialog v-model="conf_popup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center pa-0">
            <span
              style="font-weight: 600;"
              v-if="
                this.pending_app_item.type_of_approval === 'Buyer Activation' &&
                approval_action == 'Approve'
              "
            >
              Approval Validaty Date
            </span>
            <span
              style="font-weight: 600;"
              v-if="
                this.pending_app_item.type_of_approval === 'Buyer Activation' &&
                approval_action == 'Reject'
              "
            >
              Remarks
            </span>
            <span
              style="font-weight: 600;"
              v-if="
                (this.pending_app_item.type_of_approval ==
                  'PRD Serial Number Update' ||
                  this.pending_app_item.type_of_approval ===
                    'Pre packaging validation') &&
                approval_action == 'Reject'
              "
            >
              Remarks
            </span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="conf_popup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text
            class="text-center"
            v-if="
              this.pending_app_item.type_of_approval !== 'Buyer Activation' &&
              ((this.pending_app_item.type_of_approval !==
                'PRD Serial Number Update' &&
                this.pending_app_item.type_of_approval !==
                  'Pre packaging validation') ||
                approval_action != 'Reject')
            "
          >
            <span> {{ message }} </span>
          </v-card-text>
          <v-card-text class="text-center"
            v-if="this.pending_app_item.type_of_approval === 'Buyer Activation' ||
              ((this.pending_app_item.type_of_approval === 'PRD Serial Number Update' || this.pending_app_item.type_of_approval ==='Pre packaging validation') && approval_action === 'Reject')">
            <v-row>
              <v-col cols="13" sm="12" md="12" v-if="this.pending_app_item.type_of_approval === 'Buyer Activation' && approval_action === 'Approve'" >
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" value.sync="bid_start_date" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ props }">
                    <v-text-field variant="outlined" v-model="formattedStartDate" label="Select Date" prepend-inner-icon="mdi-calendar" readonly v-bind="props" :rules="inputRules"></v-text-field>
                  </template>
                  <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                    <v-date-picker :min="minAllowDate()" v-model="isDatePickerBidStartDate" hide-header color="primary" min-width="200" max-width="315" scrollable> </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="text" color="primary" @click="menu1 = false">Cancel</v-btn>
                      <v-btn
                        variant="text"
                        color="primary"
                        @click=" handleSaveDate('menu1','bid_start_date','isDatePickerBidStartDate')"
                      >
                        OK
                      </v-btn>
                    </v-card-action>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="13" sm="12" md="12" v-if="(this.pending_app_item.type_of_approval === 'PRD Serial Number Update' || this.pending_app_item.type_of_approval === 'Buyer Activation' || this.pending_app_item.type_of_approval === 'Pre packaging validation') && approval_action === 'Reject'">
                <v-text-field v-model="entered_reson" label="Enter Reason for Reject" variant="outlined" class="ma-2"> </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary" v-if="approval_action == 'success'" variant="flat" class="mb-3 text-none" @click="loadData">Ok</v-btn>
            <v-btn color="primary" v-if="approval_action == 'Approve' || approval_action == 'Reject'" variant="outlined" class="mb-3 text-none" @click="conf_popup = false">Cancel</v-btn>
            <v-btn color="primary" v-if="approval_action == 'Approve' || approval_action == 'Reject'" variant="flat" class="mb-3 text-none" @click="approveRejectItems" :disabled="number > 0">Confirm</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <GradingDetailsDialog v-model:show="dialogVisible" :item="return_items_data" />

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent :max-width=" pending_app_item.type_of_approval == 'No Claim (Closure)' ? '300px' : pending_app_item.type_of_approval == 'Write Off' ? '640px' : '960px'" >
        <v-card class="filter_ui v-card-100">
          <v-card-actions>
            <v-row class="ma-2">
              <!-- <v-col> -->
              <v-text-field
                v-if="
                  pending_app_item.type_of_approval == 'No Claim (Closure)' ||
                  pending_app_item.type_of_approval == 'Write Off' ||
                  pending_app_item.type_of_approval == 'Change Disposition' ||
                  pending_app_item.type_of_approval == 'Brand Call log Decision' ||
                  pending_app_item.type_of_approval == 'Not Repaired'
                "
                prepend-inner-icon="mdi-magnify"
                v-model="location"
                label="Location"
                variant="outlined"
                class="ma-2"
              >
              </v-text-field>
              <v-text-field v-if="pending_app_item.type_of_approval == 'Change Disposition'" prepend-inner-icon="mdi-magnify" v-model="curr_dispo" label="Current Disposition" variant="outlined" class="ma-2"> </v-text-field>
              <v-text-field v-if="pending_app_item.type_of_approval == 'Change Disposition'" prepend-inner-icon="mdi-magnify" v-model="prop_dispo" label="Proposed Disposition" variant="outlined" class="ma-2"> </v-text-field>
              <v-text-field
                v-if=" pending_app_item.type_of_approval == 'Write Off' || pending_app_item.type_of_approval == 'Change Disposition'"
                prepend-inner-icon="mdi-magnify"
                v-model="reason"
                label="Reason"
                variant="outlined"
                class="ma-2"
              >
              </v-text-field>
              <v-autocomplete
                v-if="pending_app_item.type_of_approval == 'PRD Serial Number Update'"
                prepend-inner-icon="mdi-magnify"
                v-model="selected_loc"
                :items="filter_loc_list"
                item-title="code"
                item-value="id"
                label="Location"
                class="ma-2"
                variant="outlined"
              />
              <v-autocomplete
                v-if="pending_app_item.type_of_approval == 'PRD Serial Number Update'"
                prepend-inner-icon="mdi-magnify"
                v-model="selected_request_by"
                :items="filter_req_by_list"
                item-title="username"
                item-value="id"
                label="Request By"
                class="ma-2"
                variant="outlined"
              />
              <v-text-field
                v-if="pending_app_item.type_of_approval == 'Brand Call log Decision' || pending_app_item.type_of_approval == 'Not Repaired'"
                prepend-inner-icon="mdi-magnify"
                v-model="brand"
                label="Brand"
                variant="outlined"
                class="ma-2"
              >
              </v-text-field>
              <v-text-field
                v-if="pending_app_item.type_of_approval == 'Brand Call log Decision'"
                prepend-inner-icon="mdi-magnify"
                v-model="approval_decision"
                label="Approval Decision"
                variant="outlined"
                class="ma-2"
              >
              </v-text-field>
              <v-text-field
                v-if="pending_app_item.type_of_approval == 'Pre packaging validation' "
                prepend-inner-icon="mdi-magnify"
                v-model="location_pre"
                label="Location"
                variant="outlined"
                class="ma-2"
              >
              </v-text-field>
              <v-autocomplete
                v-if=" pending_app_item.type_of_approval == 'Pre packaging validation'"
                prepend-inner-icon="mdi-magnify"
                v-model="branch"
                :items="branch_items"
                label="Branch"
                class="ma-2"
                variant="outlined"
              />
              <!-- </v-col> -->
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn class="text-none" size="small" variant="outlined" color="primary" @click="filteWithSubPopup = false">Cancel</v-btn>
            <v-btn class="text-none" size="small" variant="flat" color="primary" @click="loadData('filter')">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-card-title class="action-style mt-10" style="padding: 15px 25px 15px 15px;">
      <v-row class="ma-3 mb-0">
        <v-autocomplete v-model="select_field" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;" @update:model-value="changeSelectField" class="mr-4"> </v-autocomplete>
        <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="pending_return_search" label="Search" style="max-width: 300px;" variant="outlined" :disabled="!select_field" v-on:keyup.enter="loadData()"></v-text-field>
        <v-spacer></v-spacer>
        <v-card-actions style="margin-top: -26px;">
          <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" :disabled="selected.length == 0" @click="openConfirmationpopup('Approve')">Approve</v-btn>
          <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" :disabled="selected.length == 0" @click="openConfirmationpopup('Reject')">Reject</v-btn>
        </v-card-actions>
        <!-- filter -->
        <!-- Filter -->
        <v-expansion-panels v-if="filter_show_condition.includes(pending_app_item.type_of_approval)" class="custom-control_outlined m-0" ref="filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; height: 56px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons">
            <v-expansion-panel-title>Filter </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card-title>
    <!-- table content -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto;" class="p-0">
        <v-data-table
          hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
          return-object
          fixed-header
          height="100%"
          :items-per-page="pageSize"
        >
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
            <span v-if="header.key === 'buyer_id'">
              <a @click="navigateToBuyerDetails(item)" style="color: #1976d2; cursor: pointer;">
                <u>{{ item.buyer_id }}</u>
              </a>
            </span>
            <span v-if="header.key === 'test_report'">
              <a @click="viewGradoingResult(item)" style="color: #1976d2; cursor: pointer;">
                <u>View</u>
              </a>
            </span>
            <span v-else-if="header.key == 'images'">
              <span v-if="item.images.filter((item) => item).length">
                <a @click="openImage(item)" style="color: #1976d2; cursor: pointer;">
                  <u>View</u>
                </a>
              </span>
              <span v-else>-</span>
            </span>
            <span
              v-else-if="
                header.key == 'location' &&
                pending_app_item.type_of_approval == 'PRD Serial Number Update'
              "
            >
              <span v-if="item.location">
                <span v-tooltip="item[header.key].address_line1">
                  {{ item.location.address_line1.length > 20 ? item.location.address_line1.slice(0, 20) + "..." : item.location.address_line1 }}
                </span>
              </span>
              <span v-else>-</span>
            </span>
            <span v-else-if="item[header.key]">
              <span v-tooltip="item[header.key]">
                {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + "..." : item[header.key] }}
              </span>
            </span>
            <span v-else>{{ item[header.key] === 0 ? item[header.key] : "-" }}</span>
          </template>
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <div>
      <v-row class="ml-2 py-4">
        <span class="PaddingItemPerPage d-flex mt-4">
          <label class="" style="margin-top: -2px;">Rows Per Page</label>
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            class="custom-pagination-ui"
            @update:modelValue="handlePageSizeChange"
            variant="outlined"
            density="compact"
            style="margin-left: 120px; margin-top: -10px; position: absolute;"
          ></v-select>
        </span>
        <span class="item-selected" :style="this.totalCount > 9999 ? 'left:24% !important;' : ''">
          <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span>
          <span v-if="selected.length > 1">{{ selected.length }} Items Selected</span>
        </span>
        <v-spacer></v-spacer>
        <div class="d-flex">
          <span
            :class="
              this.totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'
            "
            v-if="this.totalCount > 0"
          >
            Showing Results {{ (this.page - 1) * this.pageSize + 1 }} - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}
          </span>
          <span class="PaddingItemPerPage mr-3" :style="totalPages > 7 ? 'min-width: 380px' : 'auto'">
            <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui" @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
          </span>
        </div>
      </v-row>
    </div>
  </v-card>
</template>
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
import GradingDetailsDialog from "@/components/commoncomponents/GradingDetailsDialog.vue";
export default {
  components: {
    HeaderComponent,
    GradingDetailsDialog,
  },
  data() {
    return {
      headerText: "Pending Approval",
      search: "",
      select_field: null,
      select_field_items: ["IRD", "Tag ID", "Article ID", "Serial Number"],
      pending_return_search: "",
      loading: false,
      selected: [],
      totalPages: 1,
      totalCount: "",
      pageSize: 100,
      page: 1,
      pageSizes: [50, 100, 200],
      bid_start_date: null,
      isDatePickerBidStartDate: (() => {
        const date = new Date();
        date.setDate(date.getDate() + 30);
        return date;
      })(),
      menu1: false,
      headers: [
        { title: "IRD", key: "ird" },
        { title: "Tag ID", key: "tag_id" },
        { title: "Article ID", key: "article_id" },
        { title: "Article Description", key: "article_description" },
        { title: "Serial Number", key: "serial_number" },
        { title: "Location", key: "location" },
        { title: "Recovery Till Now", key: "recovery_till_now" },
        { title: "In Process Till Now", key: "in_process_till_now" },
        { title: "Total Recovery", key: "total_recovery" },
      ],
      table_data: [],
      search_tag: "",
      filteWithSubPopup: false,
      approval_action: "Approve",
      conf_popup: false,
      message: "",
      location: "",
      reason: "",
      curr_dispo: "",
      prop_dispo: "",
      entered_reson: "",
      imagePopup: false,
      box_images_images: [],
      number: 0,
      filter_req_by_list: [],
      filter_loc_list: [],
      selected_loc: null,
      selected_request_by: null,
      approval_decision: null,
      brand: null,
      dialogVisible: false,
      return_items_data: [],
      branch: null,
      branch_items: [],
      location_pre: null,
      filter_show_condition:["No Claim (Closure)","Write Off", "Change Disposition", "Brand Call log Decision", "Not Repaired", "PRD Serial Number Update", "Pre packaging validation"],
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: "top",
        text: null,
        timeout: 7500,
        title: null,
        visible: false,
      },
    };
  },
  computed: {
    formattedStartDate() {
      if (this.bid_start_date) {
        const date = new Date(this.bid_start_date);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return "";
    },
  },
  created() {
    if (this.$route.query.is_direct && this.$route.query.type_of_approval == "Buyer_Activation") {
      this.pending_app_item = {
        type_of_approval: "Buyer Activation",
        backend_approval_path:
          "/api/v1/warehouse/remarketing_buyers/approval_requests",
      };
    } else this.pending_app_item = this.$store.state.pending_approval_item;

    this.headerText =
      this.pending_app_item.type_of_approval == "No Claim (Closure)"
        ? "No Claim (Closure) Approval"
        : this.pending_app_item.type_of_approval == "PRD Serial Number Update"
        ? "Edit Serial Number"
        : this.pending_app_item.type_of_approval;

    if (this.headerText == "Edit Serial Number") {
      this.select_field_items = ["Approval ID", "IRD", "Serial Number"];
      this.select_field = null;
      this.getFilterLoactions();
      this.getFilterRequestBy();
    }
    if (this.pending_app_item.type_of_approval == "No Claim (Closure)") {
      this.headers = [
        { title: "IRD", key: "ird" },
        { title: "Tag ID", key: "tag_id" },
        { title: "Article ID", key: "article_id" },
        { title: "Article Description", key: "article_description" },
        { title: "Serial Number", key: "serial_number" },
        { title: "Location", key: "location" },
        { title: "Recovery Till Now", key: "recovery_till_now" },
        { title: "In Process Till Now", key: "in_process_till_now" },
        { title: "Total Recovery", key: "total_recovery" },
      ];
    } else if (this.pending_app_item.type_of_approval == "Change Disposition") {
      this.headers = [
        { title: "IRD", key: "ird" },
        { title: "Tag ID", key: "tag_id" },
        { title: "Article ID", key: "article_id" },
        { title: "Article Description", key: "article_description" },
        { title: "Serial Number", key: "serial_number" },
        { title: "Location", key: "location" },
        { title: "Current Disposition", key: "current_disposition" },
        { title: "Proposed Disposition", key: "proposed_disposition" },
        { title: "Reason", key: "reason" },
        { title: "Total Recovery", key: "total_recovery" },
        { title: "Remarks", key: "remarks" },
      ];
    } else if (this.pending_app_item.type_of_approval == "Buyer Activation") {
      this.headers = [
        { title: "Approval ID", key: "id" },
        { title: "Buyer ID", key: "buyer_id" },
        { title: "Buyer Name", key: "buyer_name" },
        { title: "Buyer Organisation Name", key: "organization_name" },
        { title: "Request By", key: "initiator" },
        { title: "Request Date", key: "approval_request_date" },
      ];
    } else if (this.pending_app_item.type_of_approval == "PRD Serial Number Update") {
      this.headers = [
        { title: "Approval ID", key: "id" },
        { title: "Location", key: "location" },
        { title: "PRD No.", key: "prd_number" },
        { title: "IRD No.", key: "ird_number" },
        { title: "Article ID", key: "article_code" },
        { title: "Article Description", key: "article_description" },
        { title: "Existing Serial Number 1", key: "existing_serial_number1" },
        { title: "Existing Serial Number 2", key: "existing_serial_number2" },
        { title: "New Serial Number 1", key: "new_serial_number1" },
        { title: "New Serial Number 2", key: "new_serial_number2" },
        { title: "Request By", key: "request_by" },
        { title: "Request Date", key: "request_date" },
        { title: "Image", key: "images" },
      ];
    } else if (this.pending_app_item.type_of_approval == "Brand Call log Decision") {
      this.headers = [
        { title: "Tag Id", key: "tag_id" },
        { title: "Article ID", key: "article_id" },
        { title: "Article Description", key: "item_description" },
        { title: "Location ID", key: "location_id" },
        { title: "Brand.", key: "brand" },
        { title: "BCL Ticket Number", key: "ticket_number" },
        { title: "Brand Decision", key: "brand_decision" },
        { title: "Apprval Ref Number", key: "approval_ref_number" },
        { title: "Credit Note Number", key: "credit_note_number" },
        { title: "Discount Value (₹)", key: "discount_value" },
        { title: "Discount %", key: "discount_percentage" },
        { title: "Repair Type", key: "repair_type" },
        { title: "Reject Reason", key: "reject_reason" },
      ];
      this.select_field_items = [
        "Tag ID",
        "Serial Number",
        "BCL Ticket number",
      ];
    } else if (this.pending_app_item.type_of_approval == "Not Repaired") {
      this.headers = [
        { title: "Tag Id", key: "tag_id" },
        { title: "Article ID", key: "article_id" },
        { title: "Article Description", key: "item_description" },
        { title: "Location ID", key: "location_id" },
        { title: "Brand.", key: "brand" },
        { title: "Not Repaired Reason", key: "reason" },
      ];
      this.select_field_items = ["Tag ID", "Serial Number"];
    } else if (this.pending_app_item.type_of_approval == "Pre packaging validation") {
      this.filterDropdowndata();
      this.headers = [
        { title: "Branch", key: "branch" },
        { title: "CRM Ticket No.", key: "client_crm_ticket_no" },
        { title: "Sub Request ID", key: "return_sub_request_id" },
        { title: "Customer Name", key: "customer_name" },
        { title: "Customer Address.", key: "customer_address" },
        { title: "Item Location", key: "item_location" },
        { title: "Tag ID", key: "tag_number" },
        { title: "Article ID", key: "sku_code" },
        { title: "Article Description", key: "sku_description" },
        { title: "Serial Number", key: "serial_number" },
        { title: "Test Report", key: "test_report" },
      ];
      this.select_field_items = [
        "CRM Ticket No.",
        "Serial Number",
        "Sub-Request ID",
      ];
    } else {
      this.headers = [
        { title: "IRD", key: "ird" },
        { title: "Tag ID", key: "tag_id" },
        { title: "Article ID", key: "article_id" },
        { title: "Article Description", key: "article_description" },
        { title: "Serial Number", key: "serial_number" },
        { title: "Location", key: "location" },
        { title: "Reason", key: "reason" },
        { title: "Total Recovery", key: "total_recovery" },
      ];
    }
    this.loadData();
  },
  methods: {
    getRouterLink() {
      return { name: "physicalinspectionApproval" };
    },
    getRouterLinkText() {
      return "Pending Approval";
    },
    componentsName() {
      return this.pending_app_item.type_of_approval == "No Claim (Closure)"
        ? "No Claim"
        : this.pending_app_item.type_of_approval == "PRD Serial Number Update"
        ? "Edit Serial Number"
        : this.pending_app_item.type_of_approval;
    },
    openConfirmationpopup(action) {
      if (this.pending_app_item.type_of_approval == "No Claim (Closure)") {
        const irrds = new Set(this.selected.map((item) => item.ird));
        if (irrds.size !== 1) {
          this.$toast.error("Please select items with only value of ird!");
          return;
        }
        console.log(this.selected.length,this.table_data.filter((item) => irrds.has(item.ird)).length);
        if (this.selected.length != this.table_data.filter((item) => irrds.has(item.ird)).length) {
          this.$toast.error(`Please select all items with ${this.selected[0].ird} ird!`);
          return;
        }
      }
      this.approval_action = action;
      this.bid_start_date = null;
      this.conf_popup = true;
      this.number = 0;
      this.entered_reson = "";
      this.message ="Are you sure want to " + action + " the selected " + this.selected.length + " item(s) ?";
      },
    approveRejectItems() {
      this.number++;
      const params = {
        ids: this.selected.map((item) => item.id),
        user_id: this.$store.state.currentUser.id,
      };
      if (this.approval_action == "Approve") {
        params.approved_on = new Date().toISOString();
        if (this.pending_app_item.type_of_approval == "Buyer Activation")
          params.approvable_date = this.bid_start_date;
        else params.approved_on = new Date().toISOString();
      } else params.rejected_on = new Date().toISOString();
      if (this.pending_app_item.type_of_approval == "Delete PRD")
        params.params_hash = { allow_write_off: true};
      if (
        (this.pending_app_item.type_of_approval == "PRD Serial Number Update" ||
          this.pending_app_item.type_of_approval == "Buyer Activation") &&
          this.approval_action == "Reject"
      )
        params.reason = this.entered_reson;
        let endpoint = "";
        let payload = {};
        let method = "put";

      if (this.pending_app_item.type_of_approval === "Pre packaging validation") {
        method = "post";
        endpoint ="/api/v1/warehouse/return_initiation/return_creations/update_validation_approval_ticket";
        if (this.approval_action === "Approve") {
          payload = {
            ids: this.selected.map((item) => item.id),
            approved_on: new Date().toISOString(),
          };
        } else {
          payload = {
            ids: this.selected.map((item) => item.id),
            rejected_on: new Date().toISOString(),
            remarks: this.entered_reson,
          };
        }
      } else {
        endpoint = "/api/v1/approval_requests/bulk_update";
        payload = { approval_request: params }; // wrap in key as expected
      }
      this.$httpSecured[method](endpoint, payload)
        .then((response) => {
          if (response.data) {
            this.snackbar = {
              color: "success",
              icon: "mdi-check-circle",
              mode: "multi-line",
              position: "bottom",
              timeout: 3000,
              title: "Success",
              text: response.data.message,
              visible: true,
            };
            this.loadData();
          }
        })
        .catch((error) => {
          this.$toast.error(
            error.response.data.message
              ? error.response.data.message
              : error.response.data.error
          );
          this.number = 0;
          this.loading = false;
        });
    },
    loadData(action) {
      this.selected = [];
      this.table_data = [];
      this.page = 1;
      this.totalPages = 1;
      this.pageSize = 100;
      this.conf_popup = false;
      this.getdata(action);
    },
    getdata(action) {
      this.loading = true;
      const params = {
        page: this.page,
        per_page: this.pageSize,
      };
      if (this.pending_app_item.type_of_approval == "PRD Serial Number Update") {
        if (action) {
          params.filter = {};
          if (this.selected_loc) params.filter.location = this.selected_loc;
          if (this.selected_request_by)
            params.filter.requested_by = this.selected_request_by;
        } else {
          this.selected_loc = this.selected_request_by = null;
        }

      if (this.pending_return_search) {
          params.search = {};
          if (this.select_field == "IRD")
            params.search.ird_number = this.pending_return_search;
          else if (this.select_field == "Approval ID")
            params.search.approval_id = this.pending_return_search;
          else if (this.select_field == "Serial Number")
            params.search.serial_number = this.pending_return_search;
        }
      } else if (this.select_field === "IRD") {
        params.ird = this.pending_return_search;
      } else if (this.select_field === "Tag ID") {
        params.tag_number = this.pending_return_search;
      } else if (this.select_field === "Article ID") {
        params.article_id = this.pending_return_search;
      } else if (this.select_field === "Serial Number") {
        params.serial_number = this.pending_return_search;
      } else if (this.select_field === "Sub-Request ID") {
        params.search = this.pending_return_search;
      }else if (this.select_field === "CRM Ticket No.") {
        params.client_crm_ticket_no = this.pending_return_search;
      } else if (this.location) {
        params.location = this.location;
      } else if (this.reason || this.reason) {
        params.location = this.location;
        params.reason = this.reason;
      } else if (this.select_field === "BCL Ticket number") {
        params.ticket_number = this.pending_return_search;
      } else if(this.location_pre){
        params.location = this.location_pre;
      }else if(this.branch){
        params.branch = this.branch;
      }else if (this.pending_app_item.type_of_approval !== "Pre packaging validation") {
        params.location = this.location;
        params.reason = this.reason;
        params.current_disposition = this.curr_dispo;
        params.proposed_disposition = this.prop_dispo;
        params.brand = this.brand;
        params.approval_decision = this.approval_decision;
      }

      if (this.pending_app_item.type_of_approval == "Brand Call log Decision") {
        this.pending_app_item.backend_approval_path = "/api/v1/approval_requests?approval_rule_type=brand_call_log_decision";
      } else if (this.pending_app_item.type_of_approval == "Not Repaired") {
        this.pending_app_item.backend_approval_path = "/api/v1/approval_requests?approval_rule_type=not_repaired";
      } else if (this.pending_app_item.type_of_approval == "Pre packaging validation") {
        this.pending_app_item.backend_approval_path = "/api/v1/warehouse/return_initiation/return_creations/approval_request_pending_validation";
      }
      this.loading = true;
      this.$httpSecured
        .get(this.pending_app_item.backend_approval_path ? this.pending_app_item.backend_approval_path : "/api/v1/warehouse/remarketing_buyers/approval_requests",
          { params: params }
        )
        .then((response) => {
          const EXCLUDED_KEYS = new Set(['id', 'frontend_approval_path', 'backend_approval_path', 'exception_response', 'request_count']);

          const SIMPLE_APPROVAL_TYPES = new Set([
            'Pre packaging validation',
            'Not Repaired',
            'Brand Call log Decision',
            'PRD Serial Number Update',
            'Buyer Activation',
            'Change Disposition',
            'No Claim (Closure)',
          ]);

          const approvalType = this.pending_app_item.type_of_approval;
          const { approval_requests, return_items, meta } = response.data;

          if (!SIMPLE_APPROVAL_TYPES.has(approvalType) && approval_requests.length > 0) {
            this.table_data = approval_requests;

            const uniqueKeys = new Set(
              approval_requests.flatMap(row => Object.keys(row).filter(key => !EXCLUDED_KEYS.has(key)))
            );

            this.headers = [...uniqueKeys].map(key => ({
              title: key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
              align: 'start',
              sortable: false,
              key,
            }));
          } else {
            this.table_data = approvalType === 'Pre packaging validation' ? return_items : approval_requests;
          }

          this.totalPages = meta.total_pages;
          this.totalCount = meta.total_count;
          this.filteWithSubPopup = false;
          this.loading = false;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.error);
          this.loading = false;
        });
    },
    handlePageChange(value) {
      this.page = value;
      this.pending_return_search = "";
      this.getdata();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.pending_return_search = "";
      this.getdata();
    },
    changeSelectField() {
      this.pending_return_search = "";
    },
    filterListOfButtons() {
      this.filteWithSubPopup = true;
      this.location = null;
      this.reason = null;
      this.curr_dispo = null;
      this.prop_dispo = null;
      this.brand = null;
      this.approval_decision = null;
      this.selected_request_by = this.selected_loc = null;
      this.location_pre = null;
      this.branch = null;
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40
        ).toString() + "px"
      );
    },
    navigateToBuyerDetails(value) {
      this.$store.commit("setLotIds", {
        lotIds: value.buyer_uniq_id,
        action: "buyer_activation",
        inventoryId: value.buyer_id,
      });
      this.$router.push({ name: "DetailsOfBuyer" });
    },
    minAllowDate() {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date.toISOString().split("T")[0];
    },
    formatted_filter_date(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    },
    handleSaveDate(dateType, dateState, selectDateState) {
      this[dateState] = this.formatted_filter_date(this[selectDateState]);
      this[dateType] = false;
    },
    openImage(item) {
      this.box_images_images = item.images;
      if (this.box_images_images.length > 0) this.imagePopup = true;
    },
    getFilterLoactions() {
      this.$httpSecured
        .get("/api/v1/warehouse/prd/locations")
        .then((response) => {
          this.filter_loc_list = response.data;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.error);
        });
    },
    getFilterRequestBy() {
      this.$httpSecured
        .get("/api/v1/warehouse/prd/users_list")
        .then((response) => {
          this.filter_req_by_list = response.data;
        })
        .catch((error) => {
          this.$toast.error(error.response.data.error);
        });
    },
    viewGradoingResult(item) {
      this.dialogVisible = true;
      this.return_items_data = item;
    },
    filterDropdowndata() {
           this.$httpSecured.get(`/api/v1/warehouse/return_initiation/return_creations/filter_data`)
           .then((response) => {
             this.branch_items = response.data.branches;
           })
           .catch((error) => {
             console.error("Error fetching data:", error);
           });
       },
  },
};
</script>
<style scoped>
  .v-dialog:has(.filter-dispatch) {
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }

  .v-dialog > .v-card > :has(.v-card__title) {
    overflow-wrap: break-word !important;
  }

  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }

  .custom-control_outlined button {
    min-height: 56px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, 0.42);
    border-style: solid;
  }

  .custom-control_outlined button:focus {
    outline: none;
  }
  .filter_ui {
    margin-right: 20px !important;
    margin-top: 12px !important;
  }
</style>